import { create } from 'zustand';

interface ActiveShiftState {
  shift_id: string | null;
  cash_register_id: string | null;
  branch_id: string | null;
  opened_at: string | null;
  setActive: (params: {
    shift_id: string;
    cash_register_id: string;
    branch_id: string;
    opened_at: string;
  }) => void;
  clear: () => void;
}

/** Hydrated by the cashier POS shell after `me { active_shift }` resolves. */
export const useActiveShiftStore = create<ActiveShiftState>((set) => ({
  shift_id: null,
  cash_register_id: null,
  branch_id: null,
  opened_at: null,
  setActive: (params) => set({ ...params }),
  clear: () =>
    set({ shift_id: null, cash_register_id: null, branch_id: null, opened_at: null }),
}));
